import { render, staticRenderFns } from "./TheServicePoint.vue?vue&type=template&id=67b95031&"
import script from "./TheServicePoint.vue?vue&type=script&lang=js&"
export * from "./TheServicePoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports